var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTripleDot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 4,
    height: 16,
    viewBox: "0 0 4 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#878787",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 8,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 14,
    r: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTripleDot);
export default __webpack_public_path__ + "static/media/tripleDot.f8a68efc9c247efef5c530fcf3b17e82.svg";
export { ForwardRef as ReactComponent };